@include host-component-properties;

:host {
  --paf-result-row-header-horizontal-gap: 8;
  --paf-result-row-header-font-size: 16;
  --paf-icon-picto-level-1-size: 20;
  --paf-icon-picto-level-2-size: 24;
  --paf-icon-product-level-1-height: 20;
  --paf-icon-product-level-1-width: 59;
  --paf-icon-product-level-1-aspect-ratio: 59/20;
  --paf-icon-product-level-2-height: 24;
  --paf-icon-product-level-2-width: 71;
  --paf-icon-product-level-2-aspect-ratio: 71/24;

  @include mq($from: small) {
    --paf-icon-picto-level-1-size: 28;
    --paf-icon-product-level-1-height: 28;
    --paf-icon-product-level-1-width: 83;
    --paf-icon-product-level-1-aspect-ratio: 83/28;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: px-to-rem(var(--paf-result-row-header-horizontal-gap));
  position: relative;
  font-size: px-to-rem(var(--paf-result-timetable-row-font-size, var(--paf-result-row-header-font-size)));

  &.loading * {
    opacity: 0;
  }

  .loader {
    @include skeleton-loading;

    right: 50%;
  }

  .icon {
    flex-shrink: 0;
    flex-grow: 0;
    aspect-ratio: var(--paf-icon-aspect-ratio, 1 / 1);
    width: px-to-rem(#{(var(--paf-icon-width, auto))});
    height: px-to-rem(#{(var(--paf-icon-height, auto))});
  }

  .icon--picto {
    margin-inline-end: px-to-rem(calc(var(--paf-global-spacing-fixed-1x) * -1));
  }

  .icon--picto-l1 {
    --paf-icon-width: var(--paf-icon-picto-level-1-size);
    --paf-icon-height: var(--paf-icon-picto-level-1-size);
  }

  .icon--picto-l2 {
    --paf-icon-width: var(--paf-icon-picto-level-2-size);
    --paf-icon-height: var(--paf-icon-picto-level-2-size);
  }

  .icon--product-l1 {
    --paf-icon-aspect-ratio: var(--paf-icon-product-level-1-aspect-ratio);
    --paf-icon-width: var(--paf-icon-product-level-1-width);
    --paf-icon-height: var(--paf-icon-product-level-1-height);
  }

  .icon--product-l2 {
    --paf-icon-aspect-ratio: var(--paf-icon-product-level-2-aspect-ratio);
    --paf-icon-width: var(--paf-icon-product-level-2-width);
    --paf-icon-height: var(--paf-icon-product-level-2-height);
  }

  .product-text {
    font-weight: var(--paf-global-font-weight-bold);
  }

  .text {
    text-align: start;
    font-weight: var(--paf-global-font-weight-light);
    flex: 1;
  }
}

.wrapper-l1 {
  .text {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.wrapper-l2 {
  flex-wrap: wrap;

  .text {
    @include mq($to: small) {
      flex: 0 1 100%;
    }
  }
}
